/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useState, useRef, useEffect } from "react";
import { ThemeContext } from "../../pages/qcast-logo";
import {
  IoArrowBack,
  IoArrowForward,
  IoStop,
  IoStopCircleOutline,
} from "react-icons/io5";
import { Player } from "video-react";
import "video-react/dist/video-react.css";
import { RecordRTCPromisesHandler } from "recordrtc";
import { useSelector, useDispatch } from "react-redux";
import { recordDuration } from "../../functions/record-functions";
import { CircularProgressbar } from "react-circular-progressbar";
import { useMemo } from "react";

const Record = (props) => {
  const theme = useContext(ThemeContext);
  const { bg, font } = theme;
  const [record, setRecord] = useState(false);
  const [recorder, setRecorder] = useState();
  const [blob, setBlob] = useState(null);
  const [stream, setStream] = useState();
  const [timer, setTimer] = useState(0);
  const [initStream, setinitStream] = useState();
  const [startRecording, setStartRecording] = useState(false);
  const videoRef = useRef(null);
  const dispatch = useDispatch();
  const videos = useSelector((state) => state.record.recordedVideo);
  const [interval, setIntervals] = useState();

  const [countStartTime, setCountStartTime] = useState(5);
  const [countInterval, setCountInterval] = useState();

  // will change later
  const totalVideosCanMake = 3;

  useEffect(() => {
    (async function () {
      await liveRecord();
    })();

    return () => {
      stream.getTracks().forEach(function (track) {
        if (track.readyState == "live") {
          track.stop();
        }
      });
    };
  }, []);

  useEffect(() => {
    (async function () {
      if (countStartTime < 1) {
        clearInterval(countInterval);
        await startTemp();
      }
    })();
  }, [countStartTime]);

  const liveRecord = async () => {
    const stream = await navigator.mediaDevices.getUserMedia({
      audio: true,
      video: {
        width: 1280,
        height: 720,
      },
    });
    setinitStream(stream);
    const video = videoRef.current;
    video.srcObject = stream;
    video.play();
  };

  const start = async () => {
    setCountInterval(
      setInterval(() => setCountStartTime((timer) => timer - 1), 1000)
    );
  };

  const startTemp = async () => {
    setStartRecording(true);
    setCountStartTime(5);
    setCountInterval(null);
    setTimer(null);
    await liveRecord();
    if (typeof window !== "undefined") {
      const streaming = await navigator.mediaDevices.getUserMedia({
        audio: true,
        video: {
          width: 250,
          height: 250,
        },
      });
      const record = new RecordRTCPromisesHandler(streaming, {
        type: "video",
        mimeType: "video/webm;codecs=vp9",
      });
      await record.startRecording();
      setRecorder(record);
      setStream(streaming);
      setIntervals(setInterval(() => setTimer((timer) => timer + 1), 1000));
      setRecord(true);
    }
  };

  const stop = async () => {
    initStream.getTracks().forEach((track) => track.stop());
    clearInterval(interval);
    stream.stop();
    await recorder.stopRecording();
    const recordedBlob = await recorder.getBlob();
    setBlob(recordedBlob);
    dispatch({ type: "record/saveVideo", payload: recordedBlob });
    setStream(null);
    setRecorder(null);
    setRecord(false);
  };

  const newVideo = async () => {
    setBlob(null);
    await liveRecord();
    await start();
  };

  useEffect(() => {
    (async function () {
      if (timer === 60) {
        await stop();
        if (video.length < totalVideosCanMake) {
          await newVideo();
        }
      }
    })();
  }, [timer]);

  const duration = recordDuration(timer);

  const video = useMemo(() => {
    return videos?.map((item, index) => {
      const trans = index * 10 + "px";
      return (
        <video
          key={index}
          src={window.URL.createObjectURL(item)}
          className="absolute w-[2.5rem] lg:w-[2.8rem] flex-shrink-0 aspect-square rounded-full bg-white text-center border border-white"
          width={32}
          style={{ left: trans, zIndex: index }}
          height={32}
        />
      );
    });
  }, [videos]);

  return (
    <div className="w-[19rem] md:w-[24rem] lg:w-[29rem] rounded-[15px] flex flex-col overflow-hidden">
      <nav className="w-full flex flex-row justify-center space-x-2 px-2 items-center py-2 ">
        <button
          className="w-[1.2rem] h-[1.5rem] lg:w-[1.5rem] aspect-square rounded-full bg-[#8DACCD54] border border-[#D1E6FC] flex flex-col "
          onClick={() => {
            props.back();
            dispatch({ type: "record/reset" });
          }}
        >
          <IoArrowBack className="m-auto w-full text-xs lg:text-sm fill-[#2C3037]" />
        </button>
        <p
          style={{ backgroundColor: bg, color: font }}
          className="text-xs mr-4 lg:text-sm py-2 font-semibold text-[#515A6B] backdrop-blur-[50px] px-6 rounded-full w-fit justify-self-end"
        >
          Record Qcast
        </p>
        <span></span>
      </nav>
      {/* BODY */}
      <div className="w-full md:px-8 lg:px-[4rem] flex flex-col space-y-1 items-center pb-6 ">
        <span className="relative w-[270px] h-[270px] rounded-full overflow-hidden flex flex-col">
          <CircularProgressbar value={timer} maxValue={60} strokeWidth={4} />
          <div
            className={`relative ${
              countInterval ? "record-wrapper" : ""
            } w-[250px] rounded-full aspect-square m-auto mt-[.6rem] flex flex-col bg-[#FFFFFFCC]`}
          >
            {blob ? (
              <Player
                src={window.URL.createObjectURL(blob)}
                className="rounded-full overflow-hidden m-auto"
                fluid={false}
                width={250}
                aspectRatio={"1:1"}
              />
            ) : (
              <>
                {" "}
                {countInterval && (
                  <p
                    className="text-white text-4xl absolute top-[50%] left-[50%] transform -translate-y-1/2 -translate-x-1/2"
                    style={{ zIndex: "123412312312" }}
                  >
                    {" "}
                    {countStartTime}{" "}
                  </p>
                )}
                <video
                  ref={videoRef}
                  muted
                  className="h-[250px] aspect-square rounded-full m-auto object-cover"
                />
              </>
            )}
          </div>
        </span>
        <div className="w-[85%] grid grid-cols-3 bg-[#FFFFFFCC] shadow-md rounded-[20px] py-2 px-2">
          <span className="text-xs flex flex-col text-[#7B94B5]">
            <p>
              {videos.length} of {totalVideosCanMake}
            </p>
            <div className="relative flex flex-row w-full">{video}</div>
          </span>
          <span className=" flex flex-col justify-between h-full items-center mb-1">
            <p className="text-xs lg:text-sm flex flex-col text-[#515A6B] ">
              {duration ? duration : "00:00"}
            </p>
            <button
              onClick={async () => {
                if (videos?.length === totalVideosCanMake) {
                  props.review();
                  return;
                } else if (!record && videos?.length < totalVideosCanMake) {
                  await start();
                  return;
                }
                await stop();
                props.review();
              }}
              className="bg-gradient-to-b from-[#F1F9FF] to-[#DCE8F6] rounded-full p-1"
            >
              {record ? (
                <IoStop className="text-[#F88686] h-[1.5em] w-[1.5em]" />
              ) : (
                <IoStopCircleOutline className="text-[#F88686] h-[1.5em] w-[1.5em]" />
              )}
            </button>
          </span>
          {record && videos?.length < totalVideosCanMake - 1 ? (
            <span className="text-xs lg:text-sm flex flex-col justify-between justify-self-end items-center mr-4 text-[#7B94B5]">
              <p>Next</p>
              <button
                onClick={async () => {
                  await stop();
                  await newVideo();
                }}
                className="bg-gradient-to-b from-[#F1F9FF] to-[#DCE8F6] rounded-full w-fit p-1"
              >
                <IoArrowForward
                  color={bg}
                  className="text-[#97AAC3] text-sm h-[1.5em] w-[1.5em]"
                />
              </button>
            </span>
          ) : (
            <span></span>
          )}
        </div>
      </div>
    </div>
  );
};

export default Record;
